import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import React from "react";
import ReactDOM from "react-dom/client";
import { ApiError, setSignedOutHandler } from "./lib/api";
import { applyTheme, getTheme } from "./lib/theme";
import { router } from "./router";
import "./styles.css";

applyTheme(getTheme());

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      retry: (n, e) => !(e instanceof ApiError && e.status < 500) && n < 2,
      placeholderData: (prev: unknown) => prev,
    },
  },
});

// Signed out (idle or absolute timeout): sign in again and return to the same URL (SPEC §12).
setSignedOutHandler(() => {
  const here = window.location.pathname + window.location.search;
  if (!window.location.pathname.startsWith("/sign-in")) {
    queryClient.clear();
    void router.navigate({ to: "/sign-in", search: { redirect: here } });
  }
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </React.StrictMode>,
);
